import { getSupabaseClient } from '../supabaseClient';
import { API_BASE_URL, endpoints } from '../config/api';

export const chatApi = {
  /**
   * Send a manual message from business to customer
   */
  sendManualMessage: async (conversationId, messageContent, senderName = 'Support Team') => {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoints.chatManual}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          conversationId,
          messageContent,
          senderName
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to send message');
      }

      return data;
    } catch (error) {
      console.error('Error sending manual message:', error);
      throw error;
    }
  },

  /**
   * Get conversation messages with real-time updates
   */
  getConversationMessages: async (conversationId, businessType = null) => {
    const supabase = getSupabaseClient(businessType);

    const { data, error } = await supabase
      .from('chat_messages')
      .select('*')
      .eq('conversation_id', conversationId)
      .order('created_at', { ascending: true });

    if (error) throw error;
    return data;
  },

  /**
   * Subscribe to new messages in a conversation
   */
  subscribeToMessages: (conversationId, callback, businessType = null) => {
    const supabase = getSupabaseClient(businessType);

    const subscription = supabase
      .channel(`messages-${conversationId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'chat_messages',
          filter: `conversation_id=eq.${conversationId}`
        },
        callback
      )
      .subscribe();

    return subscription;
  }
}; 